/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/Confirmation/theme';

export const ConfirmationTheme = theme;
